import {useUser} from '../../auth/ui/use-user';
import {queryClient} from '@common/http/query-client';
import {Subscription} from '@common/billing/subscription';
import {User} from '@ui/types/user';

export interface BillingSource {
  subscription?: Subscription;
  user?: User;
  tenantId?: number;
  tenant?: Subscription['tenant'];
  isLoading: boolean;
  source: 'user' | 'tenant';
  invalidate?: () => void;
}

export function useBillingUser(): BillingSource {
  const query = useUser('me', {
    with: ['subscriptions.product', 'subscriptions.price', 'subscriptions.tenant'],
  });

  const subs = (query.data?.user.subscriptions || []) as Subscription[];
  const subscription = subs.find(sub => sub.active || !sub.ends_at) || subs[0];

  return {
    subscription,
    isLoading: query.isLoading,
    user: query.data?.user,
    tenantId: subscription?.tenant_id,
    tenant: subscription?.tenant,
    source: 'user',
    invalidate: invalidateBillingUserQuery,
  };
}

export function invalidateBillingUserQuery() {
  queryClient.invalidateQueries({queryKey: ['users']});
}
